// extracted by mini-css-extract-plugin
export default {"formContainer":"renew-subscription-screen_formContainer__ZUcmK","paymentsContainer":"renew-subscription-screen_paymentsContainer__Pgoxu"};